import React from "react";
import styles from "./ParagraphComponent.scss";

export const ParagraphComponent = ({ attributes, children, style }) => (
    <div className={styles.base} style={style} {...attributes}>
        {children}
    </div>
);
